(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zaikosync-media-tracking"] && !Shopify.designMode) return;
  try {
    class ZaikoMediaClock {
  constructor(media, now) {
    this.media = media.map((entry) => ({ ...entry, visibleMs: 0, continued: false, zooms: 0 }));
    this.startedAt = now;
    this.previousAt = now;
    this.currentId = null;
    this.lastMediaId = null;
  }

  tick(now, nextId) {
    const delta = Math.max(0, Math.min(now - this.previousAt, 2000));
    const current = this.media.find((entry) => entry.id === this.currentId);
    if (current) {
      current.visibleMs += delta;
      if (current.visibleMs >= 1000 && this.lastMediaId !== current.id) {
        const previous = this.media.find((entry) => entry.id === this.lastMediaId);
        if (previous) previous.continued = true;
        this.lastMediaId = current.id;
      }
    }
    this.previousAt = now;
    this.currentId = nextId;
  }

  snapshot(now) {
    return {
      elapsedMs: Math.min(14_400_000, Math.max(0, Math.round(now - this.startedAt))),
      media: this.media.map((entry) => ({ ...entry, visibleMs: Math.round(entry.visibleMs) })),
      lastMediaId: this.lastMediaId,
    };
  }
}

if (!customElements.get('zaikosync-media-tracker')) {
  customElements.define('zaikosync-media-tracker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || window.Shopify?.designMode) return;
      this.initialized = true;
      this.gallery = document.getElementById(this.dataset.galleryId);
      if (!this.gallery || !window.crypto?.randomUUID) return;
      this.controller = new AbortController();
      this.clock = null;
      this.sequence = 0;
      this.zoomId = null;
      this.navigation = null;
      this.frame = null;
      this.modal = document.getElementById('MediaZoomModal');
      const signal = this.controller.signal;
      const schedule = () => {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sample(); });
      };
      this.observer = new MutationObserver(schedule);
      this.observer.observe(this.gallery, { attributes: true, subtree: true, childList: true, attributeFilter: ['class', 'src', 'style'] });
      if (this.modal) this.observer.observe(this.modal, { attributes: true, attributeFilter: ['hidden'] });
      this.intersection = new IntersectionObserver(schedule, { threshold: [0, 0.5, 1] });
      this.intersection.observe(this.gallery.querySelector('.media-gallery__viewport') || this.gallery);
      document.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      this.gallery.addEventListener('load', schedule, { capture: true, signal });
      this.modal?.addEventListener('load', schedule, { capture: true, signal });
      this.gallery.addEventListener('click', (event) => {
        const trigger = event.target.closest?.('.media-zoom-trigger');
        if (trigger) {
          this.zoomId = trigger.dataset.mediaId;
          const media = this.clock?.media.find((entry) => entry.id === this.zoomId);
          if (media) media.zooms += 1;
        }
        schedule();
        this.queueSend();
      }, { signal, capture: true });
      this.gallery.addEventListener('touchend', () => this.queueSend(), { passive: true, signal });
      document.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[href]');
        if (!link || link.target === '_blank' || link.hasAttribute('download') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        let url;
        try { url = new URL(link.href, location.href); } catch { return; }
        if (!['http:', 'https:'].includes(url.protocol)) return;
        if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search) return;
        const kind = url.origin !== location.origin ? 'external'
          : /^\/(cart|checkout)(\/|$)/.test(url.pathname) ? 'cart'
          : /\/products\//.test(url.pathname) ? 'product' : 'internal';
        this.navigation = { kind, at: performance.now() };
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        const idBeforeHide = this.clock?.currentId;
        this.sample();
        if (document.visibilityState === 'hidden') {
          clearTimeout(this.sendTimer);
          this.sendTimer = null;
          this.hiddenMediaId = idBeforeHide;
          this.hiddenAt = performance.now();
          this.send('hidden', null, true);
        } else {
          this.hiddenMediaId = null;
          this.send(this.visibleId() ? 'visible' : 'offscreen');
        }
      }, { signal });
      window.addEventListener('pagehide', (event) => {
        clearTimeout(this.sendTimer);
        this.sendTimer = null;
        const now = performance.now();
        const idBeforeExit = this.clock?.currentId || (now - (this.hiddenAt ?? -Infinity) < 1000 ? this.hiddenMediaId : null);
        if (this.clock) this.clock.tick(now, null);
        const qualifiedExit = this.clock?.media.some((m) => m.id === idBeforeExit && m.visibleMs >= 1000) ? idBeforeExit : null;
        this.send('pagehide', qualifiedExit, true);
      }, { signal });
      window.addEventListener('pageshow', () => {
        this.hiddenMediaId = null;
        this.navigation = null;
        if (this.clock) this.clock.previousAt = performance.now();
        this.sample();
        this.send(this.visibleId() ? 'visible' : 'offscreen');
      }, { signal });
      document.addEventListener('visitorConsentCollected', () => this.updateConsent(), { signal });
      this.timer = setInterval(() => {
        this.updateConsent();
        this.sample();
        if (document.visibilityState === 'visible' && performance.now() - (this.lastSentAt || 0) >= 15_000) {
          this.send(this.visibleId() ? 'visible' : 'offscreen');
        }
      }, 1000);
      if (window.Shopify?.customerPrivacy) this.updateConsent();
      else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error && this.isConnected) this.updateConsent();
      });
    }

    permitted() {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    }

    updateConsent() {
      if (!this.permitted()) {
        this.clock = null;
        clearTimeout(this.sendTimer);
        this.sendTimer = null;
        return;
      }
      if (!this.clock && this.isConnected) {
        const media = Array.from(this.querySelectorAll('[data-id]')).map((entry) => ({
          id: entry.dataset.id,
          position: Number(entry.dataset.position),
          imageUrl: new URL(entry.dataset.imageUrl, location.href).href,
          alt: (entry.dataset.alt || '').slice(0, 300),
        }));
        if (!media.length) return;
        this.visitId = crypto.randomUUID();
        this.sequence = 0;
        this.clock = new ZaikoMediaClock(media, performance.now());
        this.sample();
        this.queueSend();
      }
    }

    visibleId() {
      if (document.visibilityState !== 'visible') return null;
      if (this.modal && !this.modal.hidden) {
        const img = this.modal.querySelector('.media-zoom-modal__image');
        return img?.complete && img.naturalWidth > 0 ? this.zoomId : null;
      }
      const item = this.gallery.querySelector('.media-gallery__item.is-active[data-media-type="image"]');
      const img = item?.querySelector('.media-gallery__image');
      if (!img?.complete || img.naturalWidth <= 0) return null;
      const rect = img.getBoundingClientRect();
      const viewport = this.gallery.querySelector('.media-gallery__viewport').getBoundingClientRect();
      const width = Math.max(0, Math.min(rect.right, viewport.right, innerWidth) - Math.max(rect.left, viewport.left, 0));
      const height = Math.max(0, Math.min(rect.bottom, viewport.bottom, innerHeight) - Math.max(rect.top, viewport.top, 0));
      if (rect.width * rect.height <= 0 || width * height / (rect.width * rect.height) < 0.5) return null;
      const id = item.dataset.mediaId.split('-').at(-1);
      return this.clock?.media.some((m) => m.id === id) ? id : null;
    }

    sample() {
      if (!this.clock || !this.permitted()) return;
      const now = performance.now();
      if (now - this.clock.startedAt > 14_400_000) {
        this.clock.currentId = null;
        return;
      }
      this.clock.tick(now, this.visibleId());
    }

    queueSend() {
      if (!this.clock || this.sendTimer) return;
      this.sendTimer = setTimeout(() => {
        this.sendTimer = null;
        if (document.visibilityState !== 'visible') return;
        this.sample();
        this.send(this.visibleId() ? 'visible' : 'offscreen');
      }, 2000);
    }

    send(state, exitMediaId = null, beacon = false) {
      if (!this.clock || !this.permitted()) return;
      const now = performance.now();
      this.lastSentAt = now;
      const body = JSON.stringify({
        version: 1,
        visitId: this.visitId,
        productId: this.dataset.productId,
        handle: this.dataset.handle,
        title: this.dataset.title.slice(0, 300),
        device: matchMedia('(max-width: 750px)').matches ? 'mobile' : 'desktop',
        sequence: ++this.sequence,
        ...this.clock.snapshot(now),
        state,
        navigation: state === 'pagehide' && this.navigation && now - this.navigation.at < 3000 ? this.navigation.kind : null,
        exitMediaId,
      });
      if (new Blob([body]).size > 60_000) return;
      if (beacon && navigator.sendBeacon?.(this.dataset.endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
      fetch(this.dataset.endpoint, {
        method: 'POST', body, headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        credentials: 'omit', keepalive: true, mode: 'cors',
      }).catch(() => {});
    }

    disconnectedCallback() {
      if (this.clock) this.clock.tick(performance.now(), null);
      this.send('offscreen');
      this.controller?.abort();
      this.observer?.disconnect();
      this.intersection?.disconnect();
      clearInterval(this.timer);
      clearTimeout(this.sendTimer);
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
